<template>
  <b-card class="rounded-0 change-fonts border_0" body-class="px-4 py-4">
    <template v-if="jobQuestion">
      <b-row class="mb-3">
        <b-col class="d-flex justify-content-center">
          <b-button
            variant="v3_teal_outline"
            :class="isSaveButtonEnabled ? 'save_preference_button' : ''"
            :disabled="!isSaveButtonEnabled"
            @click="$emit('save')"
          >
            <template v-if="!isSaveLoading">Save Preference</template>
            <template v-else>
              <b-spinner small />
              <span>Saving...</span>
            </template>
          </b-button>
        </b-col>
      </b-row>
      <div class="v3_color_black_knight">
        <div class="mb-2 font_size_1125rem font-weight-bold v3_color_teal my-0 border_bottom_1 border_bottom_light_teal">
          {{ jobQuestion.chart_title ? jobQuestion.chart_title :  jobQuestion.label}}
        </div>
        <div v-html="memberPrompt"></div>
      </div>
      <preference-chart-input
        ref="preference_input"
        class="my-3 font-size-875rem"
        :job-question="jobQuestion"
        @set-preference="onUpdatePreference"
      />
      <div class="preference-chart-body">
        <preference-chart-my-values
            v-if="isMyValuesShown"
            :study-question="studyQuestion"
        />
        <b-row v-if="studyQuestion">
          <b-col lg="10" md="12" offset-lg="1">
            <b-alert v-if="isInsufficient" show variant="warning" class="mt-3">
              There is not enough data to display.
            </b-alert>
            <preference-chart-builder v-else :job-question="jobQuestion" :key="jobQuestion.id" />
          </b-col>
        </b-row>
      </div>
    </template>
    <template v-else-if="this.$route.params.isNew">
      <div>
        <h2 class="instruction d-flex flex-column align-items-start">
          <div class="d-flex align-items-center font_size_1000rem text-center v3_color_teal flex-column justify-content-center w-100">
            <span>1. Click each "Core ICO Term" in the left menu to set the job terms of your desired ideal career opportunity.</span><p />
            <span>2. Save your preferences as you build.</span><p />
            <span>3. Click "Post to Exchange" when your ICO is complete. Remember, all ICOs are posted anonymously.</span><p />
            <!-- <span>4. Click "Post to Exchange" when your ICO is complete.</span><p /> -->
          </div>
          <!-- <div class="mt-5 pt-1 d-flex align-items-center">
            <span>2. Select Additional ICO Terms if desired.</span>
          </div>
          <div class="mt-5 pt-1 d-flex align-items-center">
            <span>3. Name your ICO for ease of reference on your Dashboard.</span>
          </div>
          <div class="mt-5 pt-1 d-flex align-items-center">
            <span>4. Click "Post to Exchange" when your ICO is complete.</span>
          </div> -->
        </h2>
      </div>
    </template>
    <template v-else>
      <div>
        <h2 class="instruction d-flex flex-column align-items-start">
          <div class="d-flex align-items-center font_size_1000rem text-center v3_color_teal flex-column justify-content-center w-100">
            <span>1. To edit each ICO Term, click on that Term in the left menu.</span><p />
            <!-- <span>2. Reminder that all ICOs must include criteria for the 3 "Core ICO Terms."</span><p /> -->
            <span>2. Repost your ICO to the Exchange when you have finished editing it.</span><p />
          </div>
          <!-- <div class="pt-1 d-flex align-items-center text-center v3_color_teal flex-column justify-content-center w-100">
            <span>2. Reminder that all ICOs must include criteria for the 3 "Core ICO Terms."</span>
          </div>
          <div class="pt-1 d-flex align-items-center text-center v3_color_teal flex-column justify-content-center w-100">
            <span>3. Repost your ICO to the Exchange when you have finished editing it.</span>
          </div> -->
        </h2>
      </div>
    </template>
  </b-card>
</template>

<script>
import PreferenceChartInput from '@/components/exchange/job-profile-details/PreferenceChartInput';
import PreferenceChartBuilder from '@/components/exchange/job-profile-details/PreferenceChartBuilder';
import PreferenceChartMyValues from '@/components/exchange/job-profile-details/PreferenceChartMyValues';
import sanitizeHtml from 'sanitize-html';
import Utils from '@/providers/Utils';
import { QUESTION_TYPES } from '@/store';

export default {
  name: 'PreferenceDetails',
  components: {
    PreferenceChartInput,
    PreferenceChartBuilder,
    PreferenceChartMyValues,
  },
  props: {
    jobQuestion: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
    isSaveButtonEnabled: {
      type: Boolean,
      default: false,
    },
    isSaveLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    studyQuestion: function () {
      return this.jobQuestion.questions &&
      Array.isArray(this.jobQuestion.questions)
          ? this.jobQuestion.questions[0]
          : null;
    },
    memberPrompt: function () {
      return this.jobQuestion
        ? sanitizeHtml(
            Utils.replaceUnderlineMarkersWithTags(
              this.jobQuestion.member_prompt
            )
          )
        : '';
    },
    isInsufficient: function () {
      return this.studyQuestion && this.studyQuestion.responses
          ? this.studyQuestion.responses.insufficient
          : true;
    },
    isMyValuesShown: function () {
      return (
          this.jobQuestion.questions.length &&
          [
            QUESTION_TYPES.SELECT_ANY,
            QUESTION_TYPES.SELECT_ONE,
            QUESTION_TYPES.YES_NO,
          ].includes(this.studyQuestion.type)
      );
    },
  },
  methods: {
    onUpdatePreference: function (...params) {
      this.$emit(
        'update-job-question',
        this.jobQuestion.type,
        this.jobQuestion.id,
        ...params
      );
    },
    isDirty: function () {
      return this.$refs.preference_input && this.$refs.preference_input.isDirty();
    },
    isValid: function () {
      return this.$refs.preference_input &&  this.$refs.preference_input.isValid();
    },
    resetValidation: function () {
      return this.$refs.preference_input &&  this.$refs.preference_input.resetValidation();
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../sass/variables_mixins.scss';
@import '../../../../sass/v3.scss';

.change-fonts .v2_control_radio_group .custom-control > .custom-control-label {
  font-size: 16px !important;
}

.change-fonts .v2_control_checkbox.custom-control > .custom-control-label {
  font-size: 16px !important;
}

.change-fonts
  .v2_control_checkbox.custom-control.custom-checkbox
  .custom-control-label::before {
  border-radius: unset !important;
}

.instruction {
  position: absolute;
  top: 30px;
  width: 45vw;
  display: flex;
  align-items: center;
  color: $phairify_secondary_color_grey;
  @extend .font_size_1125rem;

  i.mdi {
    font-size: $phairify_icon-size_xl;
    color: rgba($phairify_secondary_color_grey, 0.5);
  }
}
.save_preference_button {
  background-color: #d0de3a;
  color: $phairify_v2_color_primary_teal;
  &:hover {
    background-color: #d0de3a !important;
    color: $phairify_v2_color_primary_teal !important;
  }
}
.card{
  background-color: unset !important;
}
.font-size-875rem, .font-size-875rem label{
  font-size: .875rem !important;
}
</style>
